import * as React from "react"
import { Spinner } from "react-bootstrap"

export default function LoadingIndicatorWrapper(props: { loading: boolean, children?: React.ReactNode }) {
  if (props.loading) {
    return <div className="py-2"><Spinner animation="border" size="sm" variant="secondary" /></div>
  }
  return (<>{props.children}</>)
}
